__turbopack_context__.v({
  "fadeInUp": "workExperience-module__A9g9Uq__fadeInUp",
  "headerAnimation": "workExperience-module__A9g9Uq__headerAnimation",
  "itemAnimation": "workExperience-module__A9g9Uq__itemAnimation",
  "sectionAnimation": "workExperience-module__A9g9Uq__sectionAnimation",
});
